import Question from '@/components/Question/Question';

export default class QuestionArray {
    get all(): Question[] {
        return this._list;
    }

    private readonly _list: Question[] = [];

    constructor(list?: QuestionArray | Question[]) {
        this.fill(list);
    }

    public fill(list?: QuestionArray | Question[], limit: number = 0) {
        let questions!: Question[];

        if (list && list instanceof QuestionArray) {
            questions = list.all;
        } else if (list) {
            questions = list;
        }

        if (questions) {
            if (limit > 0 && limit < questions.length) {
                questions = questions.splice(0, limit);
            }

            for (const item of questions) {
                this.add(item);
            }
        }

    }

    public refresh(list?: QuestionArray | Question[]) {
        this.clear();
        this.fill(list);
    }

    public add(item: any) {
        this._list.push(new Question(item));
    }

    public getByIndex(index: number): Question {
        if (index > -1 && index < this._list.length) {
            return this._list[index];
        } else {
            throw Error(`index is wrong: ${index}`);
        }
    }

    public addTrust(item: Question) {
        this._list.push(item);
    }

    public clear() {
        this._list.splice(0);
    }

    get length(): number {
        return this._list.length;
    }

    // public get errorsCount(): number {
    //     let count: number = 0;
    //     for (let question of this._list) {
    //         if (question.status === false) {
    //             count++;
    //         }
    //     }
    //     return count;
    // }

    public get countAnswers(): number {
        return this._list.reduce((sum: number, current: Question) => {
            if (current.answered !== null) {
                sum++;
                return sum;
            } else {
                return sum;
            }
        }, 0);
    }

    public get firstUnAnswered(): number | null {
        for (const question of this._list) {
            if (question.status === null) {
                return this.getIndex(question);
            }
        }

        return null;
    }

    public getIndex(question: Question): number {
        return this._list.indexOf(question);
    }

    public get errorsCount(): number {
        return this._list.reduce((sum: number, current: Question) => {
            if (current.status === false) {
                sum++;
                return sum;
            } else {
                return sum;
            }
        }, 0);
    }

    public fromJSON(items: any[]) {
        this.clear();

        for (let item of items) {
            this.add(item);
        }
    }

    public isAlreadyHas(question: Question): boolean {
        return this.titles.includes(question.title);
    }

    private get titles(): string[] {
        return this._list.map(i => i.title);
    }

    public get randomIndex(): number {
        return Math.floor(Math.random() * this.length);
    }

    public merge(items: any) {
        let limit: number = 5;

        const array = new QuestionArray(items);

        while (limit > 0) {
            let question: Question = array.getByIndex(array.randomIndex);

            while (this.isAlreadyHas(question)) {
                question = array.getByIndex(array.randomIndex);
            }

            this.addTrust(question);
            limit--;
        }
    }
}
